export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="border-t bg-background py-4 px-6">
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <p>© {currentYear} Lury OS by LectioPro. All rights reserved.</p>
      </div>
    </footer>
  );
};